export const CREATE_BOOKING = "CREATE_BOOKING";
export const CREATE_BOOKING_FAILURE = "CREATE_BOOKING_FAILURE";
export const CREATE_BOOKING_SUCCESS = "CREATE_BOOKING_SUCCESS";

export const CREATE_BOOKING_HDFC = "CREATE_BOOKING_HDFC";
export const CREATE_BOOKING_HDFC_FAILURE = "CREATE_BOOKING_HDFC_FAILURE";
export const CREATE_BOOKING_HDFC_SUCCESS = "CREATE_BOOKING_HDFC_SUCCESS";

export const APPLY_COUPON = "APPLY_COUPON";
export const APPLY_COUPON_FAILURE = "APPLY_COUPON_FAILURE";
export const APPLY_COUPON_SUCCESS = "APPLY_COUPON_SUCCESS";

export const CONFIRM_BOOKING = "CONFIRM_BOOKING";
export const CONFIRM_BOOKING_FAILURE = "CONFIRM_BOOKING_FAILURE";
export const CONFIRM_BOOKING_SUCCESS = "CONFIRM_BOOKING_SUCCESS";

export const FETCH_BOOKING = "FETCH_BOOKING";
export const FETCH_BOOKING_FAILURE = "FETCH_BOOKING_FAILURE";
export const FETCH_BOOKING_SUCCESS = "FETCH_BOOKING_SUCCESS";

export const FETCH_BOOKING_BY_ID = "FETCH_BOOKING_BY_ID";
export const FETCH_BOOKING_BY_ID_FAILURE = "FETCH_BOOKING_BY_ID_FAILURE";
export const FETCH_BOOKING_BY_ID_SUCCESS = "FETCH_BOOKING_BY_ID_SUCCESS";

export const CANCEL_BOOKING = "CANCEL_BOOKING";
export const CANCEL_BOOKING_FAILURE = "CANCEL_BOOKING_FAILURE";
export const CANCEL_BOOKING_SUCCESS = "CANCEL_BOOKING_SUCCESS";

export const GET_PRICES = "GET_PRICES";
export const GET_PRICES_FAILURE = "GET_PRICES_FAILURE";
export const GET_PRICES_SUCCESS = "GET_PRICES_SUCCESS";

export const CHECK_BOOKING = "CHECK_BOOKING";
export const CHECK_BOOKING_FAILURE = "CHECK_BOOKING_FAILURE";
export const CHECK_BOOKING_SUCCESS = "CHECK_BOOKING_SUCCESS";

export const SAVE_PROPERTY_FOR_NEXT = "SAVE_PROPERTY_FOR_NEXT";
export const REMOVE_PROPERTY_FOR_NEXT = "REMOVE_PROPERTY_FOR_NEXT";
export const RESET_BOOKING_CHECKOUT = "RESET_BOOKING_CHECKOUT";

export const REMOVE_COUPON = "REMOVE_COUPON";

export const GET_ELIGIBLE_COUPONS = "GET_ELIGIBLE_COUPONS";
export const GET_ELIGIBLE_COUPONS_FAILURE = "GET_ELIGIBLE_COUPONS_FAILURE";
export const GET_ELIGIBLE_COUPONS_SUCCESS = "GET_ELIGIBLE_COUPONS_SUCCESS";
export const GET_ELIGIBLE_COMPLIMENTARY_ADDONS = "GET_ELIGIBLE_COMPLIMENTARY_ADDONS";
export const GET_ELIGIBLE_COMPLIMENTARY_ADDONS_FAILURE = "GET_ELIGIBLE_COMPLIMENTARY_ADDONS_FAILURE";
export const GET_ELIGIBLE_COMPLIMENTARY_ADDONS_SUCCESS = "GET_ELIGIBLE_COMPLIMENTARY_ADDONS_SUCCESS";
export const CLEAR_ELIGIBLE_COMPLIMENTARY_ADDONS = "CLEAR_ELIGIBLE_COMPLIMENTARY_ADDONS";
